import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import Bubble from './Bubble'

export const VideoContent = styled.video`
  width: 100%;
  height: auto;
`

const VideoMessage = ({ isLeft, payload: {url}, avatar, endOfBlock, createdAt}) => {

  return (
    <Bubble
      isLeft={isLeft}
      avatar={avatar}
      endOfBlock={endOfBlock}
      width='60%'
      timestamp={createdAt}
      stampStyle='video'
    >
      <VideoContent src={url} controls />
    </Bubble>
  )
}
export default VideoMessage

VideoMessage.propTypes = {
  avatar: PropTypes.any,
  isLeft: PropTypes.bool,
  payload: PropTypes.object.isRequired,
  endOfBlock: PropTypes.bool,
  createdAt: PropTypes.instanceOf(Date)
}
